// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3S5pz","colMaxWidth":"Table_colMaxWidth__20Ked"};